import { TopupResponseModel } from "api/repositories/packagesManagement/topupManagement/model/TopupResponseModel";
import { isEmpty } from "lodash";
import { ReactNode } from "react";
import { SummaryInfo } from "./ListBaseApiResponseModel";

export class BaseApiResponseModel<T extends Object> {
  data?: T | T[] | any;
  items?: T | T[] | any;
  pagination?: Paging;
  paging?: Paging;
  pagingnation?: Paging;
  summary?: SummaryInfo;
  total?: SummaryInfo;
  extras?: {
    extras?: Error;
  };
  rawData?: {
    data?: T;
    items?: T;
    pagination?: Paging;
    paging?: Paging;
    pagingnation?: Paging;
    summary?: SummaryInfo;
    extras?: {
      extras?: Error;
    };
  };
  file?: {
    id?: string;
  };
  passedDelete: any;
  constructor(
    data?: T | T[] | any,
    public message?: string,
    public error?: Error,
    public code?: number,
    public report?: Report,
    public passedData?: TopupResponseModel[] | [],
    pagination?: Paging,
    summary?: SummaryInfo,
    total?: SummaryInfo
  ) {
    this.data = data;
    this.pagination = pagination;
    this.summary = summary;
    this.total = total;
  }
}
export class SingleBaseResponseModel<T extends Object> {
  data: {
    data?: T;
    error?: Error;
    message?: string;
    code?: number;
  };
}

export class RevenueInfo {
  USD?: number;
  VND?: number;

  constructor(data?: Partial<RevenueInfo>) {
    this.USD = data?.USD;
    this.VND = data?.VND;
  }
}

export class Paging {
  limit?: number;
  page?: number;
  total?: number;
  success?: number;
  error?: number;
  other?: number;
  revenue?: RevenueInfo;
  deposit?: RevenueInfo;
  withdrawal?: RevenueInfo;
  debit?: RevenueInfo;
  refund?: RevenueInfo;
}

export class Error {
  status?: number;
  statusText?: string;
  code?: number;
  message?: string;
  extras?: {
    extras?: Error;
  };

  mapErrorRes?(error: Error) {
    if (!!error?.extras?.extras && !isEmpty(error?.extras?.extras)) {
      let extrasMess = error?.extras?.extras;
      return {
        status: error?.status,
        code: extrasMess?.code,
        message: extrasMess?.message || error?.statusText,
      };
    } else {
      return {
        status: error?.status,
        code: error?.code,
        message: error?.message || error?.statusText,
      };
    }
  }
}

export class Report {
  day?: number;
  week?: number;
  month?: number;
  lastMonth?: number;
}

export class Result {
  type: "success" | "error";
  message: string;
}

export class SelectList {
  label?: string;
  value?: any;
  color?: string;
  code?: string;
  userStoreId?: string;
  type?: number;
  providerCode?: string;
  isStore?: boolean;
  icon?: ReactNode;
}

export default {
  BaseApiResponseModel,
  Error,
};
